import Vue from 'vue';
import VueRouter from 'vue-router';
import { NotFound } from 'sapitur-toolkit-vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue'),
    meta: {
      auth: false,
    },
  },
  {
    path: '/home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
    meta: { auth: true },
    children: [
      {
        path: '/',
        component: () => import(/* webpackChunkName: "About" */ '../views/About.vue'),
        meta: {
          auth: true,
          breadcrumb: [{ text: 'Home' }],
        },
      },
      {
        path: '/contracheque',
        component: () => import(/* webpackChunkName: "Paycheck" */ '../views/Paycheck.vue'),
        meta: {
          auth: true,
          breadcrumb: [
            { text: 'Home', to: { path: '/home' } },
            { text: 'Contracheque Online', active: true },
          ],
        },
      },
      {
        path: '/informederendimentos',
        component: () => import(/* webpackChunkName: "ReportIncome" */ '../views/ReportIncome.vue'),
        meta: {
          auth: true,
          breadcrumb: [
            { text: 'Home', to: { path: '/home' } },
            { text: 'Informe de Rendimentos', active: true },
          ],
        },
      },
    ],
  },
  {
    path: '*',
    component: NotFound,
    meta: {
      auth: false,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const secured = to.meta.auth;
  const storage = JSON.parse(localStorage.getItem('@sapitur/servidor-online') || null);
  const isLogged = !!storage?.logged?.cpf;

  if (to.name === 'login' && isLogged) {
    next('/home');
  }

  if (secured) {
    if (isLogged) {
      next();
    } else {
      next('/');
    }
  } else next();
  next();
});

export default router;
